export const IS_AUTH = "IS_AUTH";
export const LOG_OUT = "LOG_OUT"
export const GET_OTP = "GET_OTP";
export const LOGIN_USER = "LOGIN_USER";
export const IS_SUPER_ADMIN = "IS_SUPER_ADMIN";
export const SHOW_MODAL = "SHOW_MODAL";
export const SET_TITLE = "SET_TITLE";


export const ACCESS_TOKEN = "ACCESS_TOKEN";


// export const SELECT_CLUB="SELECT_CLUB";
export const ISCOLLAPSED = "ISCOLLAPSED";
// export const IMAGE_URL="IMAGE_URL";
// export const OPEN_CREATE_SALON="OPEN_CREATE_SALON";
export const DEFINITION_SALON = "DEFINITION_SALON";
export const OPEN_DELETED_NEWBUSINESS = "OPEN_DELETED_NEWBUSINESS";
export const OPEN_CONFIRM_NEWBUSINESS = "OPEN_CONFIRM_NEWBUSINESS";
// export const OPEN_ADD_NEW_OTPCODE = "OPEN_ADD_NEW_OTPCODE ";
export const ADD_NEW_BUSINESS_STEPS = "ADD_NEW_BUSINESS_STEPS"
export const CONFIRM_COUNT = "CONFIRM_COUNT"
export const OPEN_CONTINUE_DEFINITION_SALON = "OPEN_CONTINUE_DEFINITION_SALON";
export const ADD_NEW_BUSINESS_ACTION = "ADD_NEW_BUSINESS_ACTION";
// export const GET_REQUEST_LIST="GET_REQUEST_LIST";

// export const DETAILS_DEFINITION="DETAILS_DEFINITION";

export const OPEN_GALLERY_MODAL = "OPEN_GALLERY_MODAL";

export const ADD_DETAILS_CLASS_CLUBS_STEPS = "ADD_DETAILS_CLASS_CLUBS_STEPS";

export const ADD_CREATE_CLASS_STEPS = "ADD_CREATE_CLASS_STEPS";

export const ADD_NEW_CLASS = "ADD_NEW_CLASS";
export const ADD_EDIT_BOOKING = "ADD_EDIT_BOOKING";


// export const ADD_ADMIN_PERSON = "ADD_ADMIN_PERSON";
export const ADMIN_ID = "ADMIN_ID";

export const GET_PACKAGE_CLASS = "GET_PACKAGE_CLASS";

// export const ADD_NEW_OTP="ADD_NEW_OTP";

export const ADD_NEW_UNIT_STEPS = "ADD_NEW_UNIT_STEPS"


export const PAGE_TITLE = 'PAGE_TITLE';
export const RELOAD_MODAL = 'RELOAD_MODAL';

export const CLASS_SELECTED_DATE = 'CLASS_SELECTED_DATE';
export const SELECTED_BUSINESS = 'SELECTED_BUSINESS';
export const HEADER_PORTAL_CONTAINER = 'HEADER_PORTAL_CONTAINER';

export const NEW_CLASS_SESSION_OBJECT = 'NEW_CLASS_SESSION_OBJECT';
export const BLOCK_FETCHING = 'BLOCK_FETCHING';
export const NEW_CUSTOMER_DATA = 'NEW_CUSTOMER_DATA';

export const FUNCTIONS_HELPER = 'FUNCTIONS_HELPER';
export const BOOKING_SANS_DATA = 'BOOKING_SANS_DATA';
export const NEW_SANS_SESSION_OBJECT = 'NEW_SANS_SESSION_OBJECT';




export const SANS_SELECTED_DATE = 'SANS_SELECTED_DATE';

